import { Machine, interpret, assign } from 'xstate'
import { Config } from '@nw/shared/config'
import {
  MAINTENANCE_MACHINE_ID,
  WORKING_STATE,
  MAINTENANCE_STATE,
  MAINTENANCE
} from './maintenanceMachineConstants'

export const maintenanceMachine = Machine({
  id: MAINTENANCE_MACHINE_ID,
  initial:
    Config.MAINTENANCE_STATUS === MAINTENANCE
      ? MAINTENANCE_STATE
      : WORKING_STATE,
  context: {
    maintenanceResponse: {
      res_status: '',
      response: '',
      time_in_seconds: 21600
    }
  },
  states: {
    working: {
      on: {
        MAINTENANCE: MAINTENANCE_STATE
      }
    },
    maintenance: {
      entry: assign({
        maintenanceResponse: (ctx: any, ent: any) =>
          ent && ent.maintenanceResponse
            ? ent.maintenanceResponse
            : ctx.maintenanceResponse
      }),
      on: {
        WORKING: WORKING_STATE
      }
    }
  }
})

export const maintenanceMachineService = interpret(
  maintenanceMachine
).onTransition(console.log)
